import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { useId, useState } from 'react'
import { LabelMasterAutocomplete } from 'src/features/labelCheck/components/LabelMasterAutocomplete'
import {
  RuleSwitch,
  RuleSwitchRow,
} from '../editResponseFormulaRule/NormalValueRow.styled'

type Props = {
  labelMasterId?: string
  setLabelMasterId: (labelMasterId: string | undefined) => void
}

export const SelectLabelMaster = ({
  labelMasterId,
  setLabelMasterId,
}: Props) => {
  const labelMasterToggleId = useId()

  const [isActive, setIsActive] = useState(!!labelMasterId)

  const onRuleDeactivate = () => {
    setIsActive(false)
    setLabelMasterId(undefined)
  }

  const handleSwitchRule = (checked: boolean) => {
    if (checked) {
      setIsActive(true)
      return
    }
    // checked が false の場合はルールを無効にした時のハンドラを呼び出す
    onRuleDeactivate()
  }

  return (
    <div>
      <RuleSwitchRow>
        <RuleSwitch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          aria-labelledby={labelMasterToggleId}
          checked={isActive}
          onChange={handleSwitchRule}
        />
        <label id={labelMasterToggleId}>ラベルマスタを指定する</label>
      </RuleSwitchRow>
      <LabelMasterAutocomplete
        value={labelMasterId}
        disabled={!isActive}
        onChangeLabelMaster={setLabelMasterId}
      />
    </div>
  )
}
